import { Env } from "../../enums/env.enum";

export const getEnvName = (env: Env): string => {
    switch (env) {
        case Env.trial:
            return "Trial";
        case Env.epic:
            return "EPIC";
        case Env.mba:
            return "MBA";
        case Env.mgtdsStudent:
            return "MGTDS Student";
        case Env.mgtdsInstructor:
            return "MGTDS Instructor";
        case Env.nanci:
            return "NANCI";
        case Env.lafon:
            return "LAFON";
        case Env.visconti:
            return "VISCONTI";
        case Env.sales:
            return "Sales";
    }
};
